import "./styles.scss";
import { formatNumber } from "../../../../services/utility/utils";
import { ReactComponent as UpDownIcon } from "../../../../assets/images/up-down-icon.svg";
import { ReactComponent as UpDownIcon2 } from "../../../../assets/images/up-down-icon_v1.svg";
import { formatNumberForOdds } from "../../../../utils/utils";

interface TypeContestOdd {
  value: number;
  side: "above" | "below";
  animated?: boolean;
  operatorId?: number;
}

const ContestOdd = ({
  value,
  side,
  animated = false,
  operatorId,
}: TypeContestOdd) => {
  return (
    <div
      className={`wrapper-contest-odd ${side} ${animated ? "animated" : ""}`}
    >
      {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />}
      <span className="value">{formatNumberForOdds(value)}</span>
    </div>
  );
};

export default ContestOdd;
